import { APP_SETUP_PAGE } from 'src/constants';
import { useFeatureFlags } from 'src/context/flagsContext';

export const useAppLibraryLabel = () => {
  const { EnableAppSetup } = useFeatureFlags();
  return EnableAppSetup ? 'App Library' : APP_SETUP_PAGE.label;
};
